export const network = {
    chainId: '0x' + (56).toString(16), // 目标链ID
    chainName: 'BNB Smart Chain',
    nativeCurrency: {
        name: 'BNB',
        symbol: 'BNB',
        decimals: 18
    },
    rpcUrls: ['https://56.rpc.thirdweb.com'], 
    blockExplorerUrls: ['https://bscscan.com']
}